import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { IconButton, TextField } from '@mui/material';
import { Close, ContentCopy } from '@mui/icons-material';
import { Button } from '@src/components/ui/button/button';
import PropTypes from 'prop-types';
import toastr from 'toastr';

const SOCIAL_MEDIA = [
    {
        name: 'email',
        onClick: ({ encodedMessage, encodedUrl }) => {
            window.location.href = `mailto:?subject=${encodedMessage}&body=${encodedUrl}`;
        },
        icon: (
            <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                    d='M26.667 5.33301H5.33366C3.86699 5.33301 2.68033 6.53301 2.68033 7.99967L2.66699 23.9997C2.66699 25.4663 3.86699 26.6663 5.33366 26.6663H26.667C28.1337 26.6663 29.3337 25.4663 29.3337 23.9997V7.99967C29.3337 6.53301 28.1337 5.33301 26.667 5.33301ZM26.667 10.6663L16.0003 17.333L5.33366 10.6663V7.99967L16.0003 14.6663L26.667 7.99967V10.6663Z'
                    fill='#5A5A5A'
                />
            </svg>
        )
    },
    {
        name: 'facebook',
        onClick: ({ encodedMessage, encodedUrl }) =>
            openInPopUp(`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedMessage}`),
        icon: (
            <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                    d='M28.9999 16.0005C28.9959 19.1777 27.8301 22.2438 25.7223 24.6213C23.6145 26.9987 20.7101 28.5233 17.5562 28.908C17.486 28.9159 17.4149 28.9089 17.3475 28.8873C17.2802 28.8658 17.2182 28.8302 17.1657 28.783C17.1131 28.7357 17.0712 28.6779 17.0426 28.6132C17.014 28.5486 16.9995 28.4786 16.9999 28.408V19.0005H19.9999C20.137 19.0008 20.2727 18.9729 20.3986 18.9185C20.5244 18.8642 20.6378 18.7845 20.7315 18.6845C20.8253 18.5845 20.8975 18.4663 20.9437 18.3373C20.9899 18.2082 21.009 18.071 20.9999 17.9342C20.9779 17.6771 20.8592 17.4378 20.6679 17.2646C20.4766 17.0914 20.2268 16.997 19.9687 17.0005H16.9999V14.0005C16.9999 13.47 17.2107 12.9613 17.5857 12.5862C17.9608 12.2112 18.4695 12.0005 18.9999 12.0005H20.9999C21.137 12.0008 21.2727 11.9729 21.3986 11.9185C21.5244 11.8642 21.6378 11.7845 21.7315 11.6845C21.8253 11.5845 21.8975 11.4663 21.9437 11.3373C21.9899 11.2082 22.009 11.071 21.9999 10.9342C21.9778 10.6766 21.8588 10.437 21.667 10.2637C21.4751 10.0904 21.2247 9.99634 20.9662 10.0005H18.9999C17.9391 10.0005 16.9217 10.4219 16.1715 11.172C15.4214 11.9222 14.9999 12.9396 14.9999 14.0005V17.0005H11.9999C11.8629 17.0002 11.7272 17.028 11.6013 17.0824C11.4755 17.1367 11.3621 17.2164 11.2683 17.3164C11.1746 17.4164 11.1023 17.5346 11.0562 17.6636C11.01 17.7927 10.9909 17.9299 10.9999 18.0667C11.0221 18.3243 11.141 18.5639 11.3329 18.7372C11.5248 18.9105 11.7752 19.0046 12.0337 19.0005H14.9999V28.4105C15.0004 28.481 14.9859 28.5509 14.9574 28.6154C14.9289 28.68 14.887 28.7377 14.8346 28.785C14.7822 28.8322 14.7204 28.8678 14.6532 28.8894C14.5861 28.9111 14.5151 28.9182 14.4449 28.9105C11.2066 28.5161 8.2344 26.9203 6.11654 24.439C3.99867 21.9577 2.88955 18.7718 3.00869 15.5117C3.25869 8.76171 8.72619 3.27421 15.4812 3.01171C17.2301 2.94396 18.9746 3.22965 20.6105 3.85166C22.2464 4.47368 23.7401 5.41925 25.0021 6.63183C26.2642 7.8444 27.2687 9.29906 27.9556 10.9088C28.6425 12.5185 28.9977 14.2503 28.9999 16.0005Z'
                    fill='#5A5A5A'
                />
            </svg>
        )
    },
    {
        name: 'x',
        onClick: ({ encodedMessage, encodedUrl }) =>
            openInPopUp(`https://twitter.com/intent/tweet?text=${encodedMessage}&url=${encodedUrl}`),
        icon: (
            <svg xmlns='http://www.w3.org/2000/svg' width='26' height='23' viewBox='0 0 26 23' fill='none'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M9.74003 12.1861L0 0.0830078H7.71479L13.7272 7.56353L20.1506 0.116689H24.3995L15.7816 10.1195L26 22.833H18.3082L11.798 14.7433L4.84765 22.8106H0.575731L9.74003 12.1861ZM19.4294 20.5905L4.73045 2.32549H6.59279L21.2732 20.5905H19.4294Z'
                    fill='#5A5A5A'
                />
            </svg>
        )
    },
    {
        name: 'linkedin',
        onClick: ({ encodedUrl }) => openInPopUp(`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`),
        icon: (
            <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
                <path
                    d='M27 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V27C3 27.5304 3.21071 28.0391 3.58579 28.4142C3.96086 28.7893 4.46957 29 5 29H27C27.5304 29 28.0391 28.7893 28.4142 28.4142C28.7893 28.0391 29 27.5304 29 27V5C29 4.46957 28.7893 3.96086 28.4142 3.58579C28.0391 3.21071 27.5304 3 27 3ZM12 22C12 22.2652 11.8946 22.5196 11.7071 22.7071C11.5196 22.8946 11.2652 23 11 23C10.7348 23 10.4804 22.8946 10.2929 22.7071C10.1054 22.5196 10 22.2652 10 22V14C10 13.7348 10.1054 13.4804 10.2929 13.2929C10.4804 13.1054 10.7348 13 11 13C11.2652 13 11.5196 13.1054 11.7071 13.2929C11.8946 13.4804 12 13.7348 12 14V22ZM11 12C10.7033 12 10.4133 11.912 10.1666 11.7472C9.91997 11.5824 9.72771 11.3481 9.61418 11.074C9.50065 10.7999 9.47094 10.4983 9.52882 10.2074C9.5867 9.91639 9.72956 9.64912 9.93934 9.43934C10.1491 9.22956 10.4164 9.0867 10.7074 9.02882C10.9983 8.97094 11.2999 9.00065 11.574 9.11418C11.8481 9.22771 12.0824 9.41997 12.2472 9.66665C12.412 9.91332 12.5 10.2033 12.5 10.5C12.5 10.8978 12.342 11.2794 12.0607 11.5607C11.7794 11.842 11.3978 12 11 12ZM23 22C23 22.2652 22.8946 22.5196 22.7071 22.7071C22.5196 22.8946 22.2652 23 22 23C21.7348 23 21.4804 22.8946 21.2929 22.7071C21.1054 22.5196 21 22.2652 21 22V17.5C21 16.837 20.7366 16.2011 20.2678 15.7322C19.7989 15.2634 19.163 15 18.5 15C17.837 15 17.2011 15.2634 16.7322 15.7322C16.2634 16.2011 16 16.837 16 17.5V22C16 22.2652 15.8946 22.5196 15.7071 22.7071C15.5196 22.8946 15.2652 23 15 23C14.7348 23 14.4804 22.8946 14.2929 22.7071C14.1054 22.5196 14 22.2652 14 22V14C14.0012 13.7551 14.0923 13.5191 14.256 13.3369C14.4197 13.1546 14.6446 13.0388 14.888 13.0114C15.1314 12.9839 15.3764 13.0468 15.5765 13.188C15.7767 13.3292 15.918 13.539 15.9738 13.7775C16.6502 13.3186 17.4389 13.0526 18.2552 13.0081C19.0714 12.9637 19.8844 13.1424 20.6067 13.5251C21.329 13.9078 21.9335 14.48 22.3551 15.1803C22.7768 15.8806 22.9997 16.6825 23 17.5V22Z'
                    fill='#5A5A5A'
                />
            </svg>
        )
    }
];

export const ShareModal = ({ open, onClose }) => {
    const [url, setUrl] = useState('');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setUrl(window.location.href);
        }
    }, []);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            toastr.success('Copied');
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const handleShare = platform => {
        const encodedUrl = encodeURIComponent(url);
        const message = 'Check out this Task listed on BCAA Task Marketplace';
        const encodedMessage = encodeURIComponent(message);

        platform.onClick({ encodedMessage, encodedUrl });
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    width: '600px',
                    maxWidth: '90%'
                }
            }}
        >
            <DialogContent className='tw-space-y-[16px]'>
                <div className='tw-flex tw-items-center'>
                    <div className='tw-text-[20px] tw-font-[500] tw-text-[#333333] tw-grow'>
                        Link copied to clipboard.
                    </div>
                    <IconButton onClick={onClose}>
                        <Close size={24} />
                    </IconButton>
                </div>
                <TextField
                    value={url}
                    multiline
                    InputProps={{
                        className: 'tw-text-[16px] tw-w-full',
                        readOnly: true
                    }}
                    SelectProps={{ className: 'tw-text-[16px] tw-w-full' }}
                    InputLabelProps={{ className: 'tw-text-[16px]' }}
                    FormHelperTextProps={{ className: 'tw-text-[12px]' }}
                    className='tw-w-full'
                />
                <div className='tw-flex tw-justify-end tw-items-center tw-w-full'>
                    <Button variant='contained' startIcon={<ContentCopy size={24} />} onClick={handleCopy}>
                        Copy
                    </Button>
                </div>
                <div className='tw-text-[20px] tw-font-[500] tw-text-[#333333]'>Share directly to social media</div>
                <div className='tw-flex tw-items-center tw-gap-[8px]'>
                    {SOCIAL_MEDIA.map(platform => (
                        <IconButton key={platform.name} onClick={() => handleShare(platform)}>
                            {platform.icon}
                        </IconButton>
                    ))}
                </div>
            </DialogContent>
        </Dialog>
    );
};

function openInPopUp(shareUrl) {
    const width = 600;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    // Open popup window
    window.open(
        shareUrl,
        'shareWindow',
        `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars=yes,status=1`
    );
}

ShareModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
